import { useIntl } from 'react-intl'
import { RoleRow } from '../../model/RoleRow'
import { PermissionPolicyOption } from '../../../../../domain/value-object/PermissionPolicy'
import { ICellRendererParams } from 'ag-grid-community'
import { MultiLineTooltip } from '../../../../components/tooltips/Tooltip/MultiLineTooltip'
import { RootDiv } from '../../../../containers/commons/AgGrid/components/cell/CellRendererRoot'
import { colorPalette } from '../../../../style/colorPalette'
import { useAvailableFunctionsTooltipGetter } from '../../../../page-properties/bulksheet-properties/permissionPolicies/availableFunctionsTooltip'
import { useCallback, useEffect, useRef } from 'react'

type UseAvailableFunctionsProps = {
  permissionPolicyOptions: PermissionPolicyOption[]
}

export const useAvailableFunctionsCellRenderer = ({
  permissionPolicyOptions,
}: UseAvailableFunctionsProps) => {
  const intl = useIntl()
  const { getAvailableFunctionsTooltipOfRole } =
    useAvailableFunctionsTooltipGetter()
  const permissionPolicyOptionsRef = useRef(permissionPolicyOptions)
  useEffect(() => {
    permissionPolicyOptionsRef.current = permissionPolicyOptions
  }, [permissionPolicyOptions])

  const cellRenderer = useCallback(
    (params: ICellRendererParams<RoleRow>) => {
      const tooltip = params.data
        ? getAvailableFunctionsTooltipOfRole(
            params.data,
            permissionPolicyOptionsRef.current
          )
        : ''

      return (
        <RootDiv>
          <MultiLineTooltip message={tooltip}>
            <span style={{ cursor: 'pointer', color: colorPalette.skyBlue[8] }}>
              {intl.formatMessage({ id: 'confirm' })}
            </span>
          </MultiLineTooltip>
        </RootDiv>
      )
    },
    [getAvailableFunctionsTooltipOfRole, intl]
  )

  return cellRenderer
}
